.registrationMultiStepTracker {
  width: 30%;
  min-width: fit-content;
  margin: auto;

  +div+p {
    margin: 1rem 0rem ;
  }
}

.mobileStepLabels {
  display: none;
}

@media (min-width: 1943px) {
  .registrationMultiStepTracker {
    width: 10%;
  }
}

@media (max-width: 800px) {
  .registrationMultiStepTracker {
    width: 100%;
  }

  .mobileStepLabels {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0.25rem;
    margin-top: 0.5rem;
    text-align: center;
  }

  .mobileStepLabel,
  .mobileStepLabelActive {
    font-size: 1rem;
    line-height: 1.2;
    overflow-wrap: anywhere;
  }

  .mobileStepLabel {
    opacity: 0.7;
  }

  .mobileStepLabelActive {
    opacity: 1;
  }
}